import { atom, selectorFamily } from "recoil";

export const lecturersState = atom({
    key: "lecturersState",
    default: [],
});

